export default function Global() {
    return null;
}

export function fadeInOnLoad(element, delay = 0) {
    if (!element) return;

    setTimeout(() => {
        element.classList.add('visible');
    }, delay);
}